import { ref, type Ref } from 'vue';
import { EstateAccountingQuebecDistribution } from '@/modules/estateaccountingquebecdistribution/models/EstateAccountingQuebecDistribution';

export const estateAccountingQuebecDistributions: Ref<
  EstateAccountingQuebecDistribution[] | undefined
> = ref(undefined);
